import { API_URL } from "constants/ApiUrl";
import fetch from "../auth/FetchInterceptor";
const ClubService = {};

ClubService.getProfile = function (role) {
  const url =
    role === "club"
      ? `${API_URL}/api/club/profile`
      : `${API_URL}/api/agent/profile`;
  return fetch({
    url: url,
    method: "get",
    headers: {
      "Content-Type": "application/json",
    },
  });
};
ClubService.getNotifs = function () {
  const url = `${API_URL}/api/club/notifications`;
  return fetch({
    url: url,
    method: "get",
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export default ClubService;
